<template>
    <div class="pa-2">
        <v-item-group active-class="zoezi-edit-color" v-model="selectedPageTemplate">
            <v-row v-for="(row, rowindex) in rows" :key="rowindex">
                <v-col :cols="12 / columns" v-for="template in row" :key="template.id">
                    <v-item :value="template" v-slot:default="{ active }">
                        <v-hover v-slot="{hover}">
                            <v-card
                                width=200
                                :elevation="hover ? 24 : 6"
                                :class="active || hover ? ['zoezi-edit-color'] : undefined"
                                ripple
                                @click="selectedPageTemplate = template; $emit('input', template)"
                            >
                                <v-card-text justify="center" align="center" :class="(active||hover)  ? 'zoezi-edit-text-color' : undefined">
                                    <v-icon :class="(active||hover)  ? 'zoezi-edit-text-color' : ''">{{template.icon}}</v-icon><br>
                                    {{$translate(template.title)}}
                                </v-card-text>
                            </v-card>
                        </v-hover>
                    </v-item>
                </v-col>
            </v-row>
        </v-item-group>
    </div>
</template>

<script>
import {chunk} from 'lodash';
export default {
    name: 'HomePageTemplatePalette',
    props: ['value'],

    computed: {
        rows() {
            return chunk(this.pageTemplates, this.columns);
        }
    },

    data: () => ({
        columns: 2,
        pageTemplates: [
            {id: 'empty', title: 'Empty', icon: 'mdi-square-outline', config: {}},
            {id: 'copy', title: 'Copy of this page', icon: 'mdi-content-copy', config: {}},
            {id: 'copyother', title: 'Copy of another page', icon: 'mdi-content-copy', config: {}},
            {id: 'gym', title: 'Gymmet', icon: 'mdi-kettlebell', config: {}},
            {id: 'yoga', title: 'Yoga-studion', icon: 'mdi-yoga', config: {}},
            {id: 'sf', title: 'Staff page', icon: 'mdi-account-multiple', config: {}}
        ],
        selectedPageTemplate: null
    })
}
</script>
